var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.index,
      ref: "modal-" + _vm.id,
      staticClass: "c-checklist-media-block__modal",
      class: { "is-open": _vm.isopen === _vm.id },
      attrs: { id: "modal-" + _vm.id }
    },
    [
      _c("div", { staticClass: "c-checklist-media-block__modal-content" }, [
        _c("div", { staticClass: "c-checklist-media-block__modal-body" }, [
          _c(
            "p",
            { staticClass: "c-checklist-media-block__modal-text text-h5" },
            [_vm._v("\n\t\t\t\t" + _vm._s(_vm.text) + "\n\t\t\t")]
          )
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "c-checklist-media-block__modal-content-pointer"
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }